import { ReferenceNumber } from "../apis/dtos";

/**
 * Filters and deduplicates reference numbers by type.
 * @param referenceNumbers The input array.
 * @param type The reference number type to filter (e.g., "PO", "BOL", "OrderNumber").
 * @returns Unique reference numbers of the given type.
 */
export function getUniqueReferenceNumbersByType(
    referenceNumbers: ReferenceNumber[],
    type: string
  ): ReferenceNumber[] {
    const seen = new Set<string>();
    return referenceNumbers.filter(
      (ref) => ref.type === type && !seen.has(ref.value) && seen.add(ref.value)
    );
  }


/**
 * Formats an array of ReferenceNumber values as a comma-separated string.
 * If the array is empty, returns '-'.
 */
export function formatReferenceValues(refs: ReferenceNumber[]): string {
    if (refs.length === 0) return "-";
    return refs.map((ref) => ref.value).join(", ");
  }